import { useCallback } from "react";
import axios from "../api/axios";
import useAuth from "./useAuth";
import {buildAuthSession} from "../helpers/AuthSession";

const useRefreshToken = () => {
  const { setAuth } = useAuth();

  return useCallback(async () => {
    const response = await axios.get('/api/token/refresh', {
      withCredentials: true
    });

    setAuth(prev => buildAuthSession(response.data, prev));
    return response.data.accessToken;
  }, [setAuth]);
};

export default useRefreshToken;
